const resources = {
    showMore: 'Show More Products',
    breadcrumb: 'Breadcrumb',
    viewing: 'Viewing',
    results: 'results'
};

module.exports = function getResource(label) {
    return resources[label];
};
